import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalService } from '../../../lib/services/modal.service';
import {
  UploadImageModalComponent,
  UploadImageModel,
  UploadImageType,
} from '../../../components/upload-image-modal/upload-image-modal.component';
import { take } from 'rxjs/operators';
import { UploadImageResponse } from '../../../lib/services/imageService';

@Component({
  selector: 'mj-image-drag-drop',
  templateUrl: './mj-image-drag-drop.component.html',
  styleUrls: ['./mj-image-drag-drop.component.scss'],
})
export class MjImageDragDropComponent {
  @Input() ratio: number[];
  @Output() onImageReceived = new EventEmitter<UploadImageResponse>();

  constructor(
    private _snackBar: MatSnackBar,
    private modalService: ModalService
  ) {}

  onUploadImage() {
    this.modalService
      .appendComponentToBody(
        UploadImageModalComponent,
        new UploadImageModel(UploadImageType.LISTING_IMAGE_TYPE, this.ratio)
      )
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.onImageReceived.emit(res);
          this._snackBar.open('Image uploaded successfully', null, {
            duration: 3000,
          });
        }
      });
  }
}
